export default __webpack_public_path__ + "static/media/insta2.93199479.png";